// extracted by mini-css-extract-plugin
module.exports = {"quantity":"OrderSummary-Quantity-module--quantity--2SbG2"};